import useAuthStore from '~/store/auth'

const apiFetch = async (url, options = {}) => {
	const baseURL = useRuntimeConfig().public.apiBase
	const token = useCookie('token')

	if (token.value) {
		;(options.headers ??= {}).Authorization = `Bearer ${token.value}`
	}

	if (options.body) {
		const { payload, hasFiles } = handlePayload(options.body)

		options.body = payload

		// Laravel nevie narabat s patch metodou a formdata
		if (
			hasFiles &&
			['PUT', 'PATCH'].includes(options?.method?.toLocaleUpperCase())
		) {
			options.method = 'POST'
			options.query = {
				...(options.query ?? {}),
				_method: 'PATCH'
			}
		}
	}

	return $fetch(url, {
		baseURL,
		...options
	})
}

export default apiFetch
